import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';

import SelectMulti from 'pre-fuse/components/SelectMulti';

class BasicMultiSelectFilter extends Component{
    constructor( props ){
        super( props );
        this.state = {
            selectedOptions: [],
        };

        this.inputRef = React.createRef();
    }

    /***
     * BEGIN ag-grid required Methods https://www.ag-grid.com/javascript-grid-filter-component/#example-filtering-using-react-components
    ***/
    getModel = () => {
        if( this.state.selectedOptions.length > 0 ){
            return { values: this.state.selectedOptions.map( selectedOption => selectedOption.value ) };
        }
        else{
            return null;
        }
    }

    isFilterActive = () => {
        return this.state.selectedOptions.length > 0;
    }

    doesFilterPass = ( params ) => {

        const { selectedOptions } = this.state;
        const { valueGetter } = this.props;
        const value =  valueGetter( params.node );

        let passesFilter = false;

        for( let group of value ){
            if( find( selectedOptions, { label: group } ) ){
                passesFilter =  true;
                break;
            }
        }

        return passesFilter;
    }

    setModel = () => {
        const { filterChangedCallback } = this.props;
        this.setState( {
            selectedOptions: []
        }, () => filterChangedCallback() );
    }

    afterGuiAttached(){
        if( this.inputRef.current ){
            this.inputRef.current.focus();
        }
    }
    /***
     * END ag-grid required methods
     ***/

    handleChange = ( newSelections ) => {
        this.setState( {
            selectedOptions: [...newSelections]
        }, () => this.props.filterChangedCallback() );
    };

    render(){
        const { selectedOptions } = this.state;
        const { context, colDef: { field } } = this.props;

        return (
            <SelectMulti
                id="basic-multiselect-filter"
                onChange={this.handleChange}
                value={selectedOptions}
                options={ [...context[field]] } //It is important you name the context the same as the filed in the colDefs used.
                selectRef={this.inputRef}
                searchPlaceholder={'Type in to Search'}
                variant="standalone"

            />
        );
    }
};

BasicMultiSelectFilter.propTypes = {
    colDef: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
    filterChangedCallback: PropTypes.func.isRequired,
    valueGetter: PropTypes.func.isRequired,
};

export default BasicMultiSelectFilter;
